//Generated File 
export const Activity = `Activity`;
export const AggrAssemblyDocument = `AggrAssemblyDocument`;
export const AssemblyAltMaterial = `AssemblyAltMaterial`;
export const AssemblyBOM = `AssemblyBOM`;
export const AssemblyComponent = `AssemblyComponent`;
export const AssemblyDocument = `AssemblyDocument`;
export const AssemblyMachine = `AssemblyMachine`;
export const AssemblyProcessFile = `AssemblyProcessFile`;
export const AssemblyRequest = `AssemblyRequest`;
export const AutoSalesPricing = `AutoSalesPricing`;
export const AutoSalesPricingSetting = `AutoSalesPricingSetting`;
export const CalculationFormula = `CalculationFormula`;
export const ConsolidatedPurchaseReq = `ConsolidatedPurchaseReq`;
export const CostRevaluation = `CostRevaluation`;
export const CustomersReqsShortageDoc = `CustomersReqsShortageDoc`;
export const DeliveryCancellationDoc = `DeliveryCancellationDoc`;
export const DeliveryConfiguration = `DeliveryConfiguration`;
export const DeliveryDocument = `DeliveryDocument`;
export const DeliveryDriverConfig = `DeliveryDriverConfig`;
export const DeliveryNumber = `DeliveryNumber`;
export const DeliveryOrganization = `DeliveryOrganization`;
export const DeliveryQueue = `DeliveryQueue`;
export const DeliveryQueueConfiguration = `DeliveryQueueConfiguration`;
export const DiscountUpdate = `DiscountUpdate`;
export const DiscountsReCalcDocument = `DiscountsReCalcDocument`;
export const EndStockTaking = `EndStockTaking`;
export const FinishedProductPricing = `FinishedProductPricing`;
export const FreeItemGroup = `FreeItemGroup`;
export const FrozenCostAccounts = `FrozenCostAccounts`;
export const GlassJobOrder = `GlassJobOrder`;
export const GlassJobOrderReq = `GlassJobOrderReq`;
export const GlassJobOrderStatusUpdate = `GlassJobOrderStatusUpdate`;
export const GlassOperationMap = `GlassOperationMap`;
export const GlassOrderList = `GlassOrderList`;
export const InitialReceipt = `InitialReceipt`;
export const InvItem = `InvItem`;
export const InvItemOpiningRequest = `InvItemOpiningRequest`;
export const InvItemUpdate = `InvItemUpdate`;
export const InvoiceClassification = `InvoiceClassification`;
export const ItemAssortment = `ItemAssortment`;
export const ItemBrand = `ItemBrand`;
export const ItemCategory = `ItemCategory`;
export const ItemClass1 = `ItemClass1`;
export const ItemClass10 = `ItemClass10`;
export const ItemClass2 = `ItemClass2`;
export const ItemClass3 = `ItemClass3`;
export const ItemClass4 = `ItemClass4`;
export const ItemClass5 = `ItemClass5`;
export const ItemClass6 = `ItemClass6`;
export const ItemClass7 = `ItemClass7`;
export const ItemClass8 = `ItemClass8`;
export const ItemClass9 = `ItemClass9`;
export const ItemColor = `ItemColor`;
export const ItemConfigurations = `ItemConfigurations`;
export const ItemCustomerLink = `ItemCustomerLink`;
export const ItemCuttingDoc = `ItemCuttingDoc`;
export const ItemRelations = `ItemRelations`;
export const ItemRequest = `ItemRequest`;
export const ItemRevisionFile = `ItemRevisionFile`;
export const ItemSection = `ItemSection`;
export const ItemSize = `ItemSize`;
export const ItemSizeColorCollection = `ItemSizeColorCollection`;
export const ItemStorageAllocation = `ItemStorageAllocation`;
export const ItemSupplierLink = `ItemSupplierLink`;
export const ItemVotingDoc = `ItemVotingDoc`;
export const ItemVotingFile = `ItemVotingFile`;
export const ItemWarehouseRelation = `ItemWarehouseRelation`;
export const JOrderExpense = `JOrderExpense`;
export const JobOrderPartialDelivery = `JobOrderPartialDelivery`;
export const LCAction = `LCAction`;
export const LCCostDoc = `LCCostDoc`;
export const LCOpeningDoc = `LCOpeningDoc`;
export const LCOpeningRequest = `LCOpeningRequest`;
export const LCProformaInvoice = `LCProformaInvoice`;
export const LCShipment = `LCShipment`;
export const LCShipmentProformaInvoice = `LCShipmentProformaInvoice`;
export const LcExpenseDocument = `LcExpenseDocument`;
export const LetterOfCredit = `LetterOfCredit`;
export const LetterOfCreditRequest = `LetterOfCreditRequest`;
export const LimitSalesQty = `LimitSalesQty`;
export const LoadingCancellationDoc = `LoadingCancellationDoc`;
export const LoadingDocument = `LoadingDocument`;
export const Locator = `Locator`;
export const MCRawMaterialIssue = `MCRawMaterialIssue`;
export const ManufacturerCertificate = `ManufacturerCertificate`;
export const MaterialClassification = `MaterialClassification`;
export const MobileAppSalesPriceList = `MobileAppSalesPriceList`;
export const MultiAssemblyDoc = `MultiAssemblyDoc`;
export const MultiItemCreator = `MultiItemCreator`;
export const OfferApplyRules = `OfferApplyRules`;
export const OpeningStockDocument = `OpeningStockDocument`;
export const OrderDamage = `OrderDamage`;
export const OrderDelivery = `OrderDelivery`;
export const OrderExecution = `OrderExecution`;
export const OrderFinished = `OrderFinished`;
export const OrderStatusQtyTrackConfig = `OrderStatusQtyTrackConfig`;
export const OutsourceIssue = `OutsourceIssue`;
export const OutsourceReceipt = `OutsourceReceipt`;
export const OutsourceRequest = `OutsourceRequest`;
export const PackagingMethodFile = `PackagingMethodFile`;
export const PartialAssemblyBOM = `PartialAssemblyBOM`;
export const PickRules = `PickRules`;
export const PostSalesOffer = `PostSalesOffer`;
export const PostSalesOfferClaim = `PostSalesOfferClaim`;
export const PostSalesOfferConfig = `PostSalesOfferConfig`;
export const PreventUsingBatch = `PreventUsingBatch`;
export const PriceVotingDoc = `PriceVotingDoc`;
export const PriceVotingFile = `PriceVotingFile`;
export const PricingRange = `PricingRange`;
export const ProcessingDoc = `ProcessingDoc`;
export const ProformaPurchaseInvoice = `ProformaPurchaseInvoice`;
export const ProformaSalesInvoice = `ProformaSalesInvoice`;
export const PurchaseDocumentUpdate = `PurchaseDocumentUpdate`;
export const PurchaseForecast = `PurchaseForecast`;
export const PurchaseInvoice = `PurchaseInvoice`;
export const PurchaseOrder = `PurchaseOrder`;
export const PurchasePriceComparing = `PurchasePriceComparing`;
export const PurchasePriceList = `PurchasePriceList`;
export const PurchaseQuotation = `PurchaseQuotation`;
export const PurchaseQuotationRequest = `PurchaseQuotationRequest`;
export const PurchaseReturn = `PurchaseReturn`;
export const PurchaseReturnReq = `PurchaseReturnReq`;
export const PurgeStockReceipt = `PurgeStockReceipt`;
export const QualityAssuranceDoc = `QualityAssuranceDoc`;
export const QualityAssuranceReq = `QualityAssuranceReq`;
export const QualityCheckList = `QualityCheckList`;
export const QualityControlDoc = `QualityControlDoc`;
export const QualityControlReq = `QualityControlReq`;
export const QuestionClassification = `QuestionClassification`;
export const RackQuantities = `RackQuantities`;
export const ReceiptAdditionalCost = `ReceiptAdditionalCost`;
export const ReceiptInspection = `ReceiptInspection`;
export const ReservationCancellationDoc = `ReservationCancellationDoc`;
export const ReservationDocument = `ReservationDocument`;
export const Resource = `Resource`;
export const SCCopierExtraFields = `SCCopierExtraFields`;
export const SCDocRuleSet = `SCDocRuleSet`;
export const SCExtraDocCreationRule = `SCExtraDocCreationRule`;
export const SalesForecast = `SalesForecast`;
export const SalesInvoice = `SalesInvoice`;
export const SalesManUpdateDocument = `SalesManUpdateDocument`;
export const SalesOffers = `SalesOffers`;
export const SalesOrder = `SalesOrder`;
export const SalesPoints = `SalesPoints`;
export const SalesPriceInPoints = `SalesPriceInPoints`;
export const SalesPriceList = `SalesPriceList`;
export const SalesQuotation = `SalesQuotation`;
export const SalesQuotationRequest = `SalesQuotationRequest`;
export const SalesReplacement = `SalesReplacement`;
export const SalesReplacementReq = `SalesReplacementReq`;
export const SalesReturn = `SalesReturn`;
export const SalesReturnRequest = `SalesReturnRequest`;
export const Season = `Season`;
export const ServiceItemBOM = `ServiceItemBOM`;
export const StandardMeasures = `StandardMeasures`;
export const StartStockTaking = `StartStockTaking`;
export const StockIssue = `StockIssue`;
export const StockIssueReq = `StockIssueReq`;
export const StockReceipt = `StockReceipt`;
export const StockReceiptCancellation = `StockReceiptCancellation`;
export const StockReceiptReq = `StockReceiptReq`;
export const StockTakingDetails = `StockTakingDetails`;
export const StockTakingElectronic = `StockTakingElectronic`;
export const StockTransfer = `StockTransfer`;
export const StockTransferReq = `StockTransferReq`;
export const Tender = `Tender`;
export const TenderCondition = `TenderCondition`;
export const UOM = `UOM`;
export const UOMConversions = `UOMConversions`;
export const UOMGroup = `UOMGroup`;
export const UpdateSeasonsDoc = `UpdateSeasonsDoc`;
export const VendorDiscount = `VendorDiscount`;
export const WareLocationClass = `WareLocationClass`;
export const Warehouse = `Warehouse`;
export const WeightScaleConfig = `WeightScaleConfig`;
export const WeightScalePrepGenerator = `WeightScalePrepGenerator`;
export const WeightScalePreparationDoc = `WeightScalePreparationDoc`;
